<div class="header">
  <h3>{{'DEPARTMENT.LIST.TITLE' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clearSearch()"></app-filter-header>

  <div class="row">
    <div class="col">
      <div class="form-label-group">
        <input class="form-control"
            type="text"
            id="department_id"
            [(ngModel)]="searchDepartmentID"
            placeholder="{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-ID' | translate}}">
        <label for="department_id">{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-ID' | translate}}</label>
      </div>
    </div>
    <div class="col">
      <div class="form-label-group">
        <input class="form-control"
            type="text"
            id="department_en"
            [(ngModel)]="searchDepartmentName"
            placeholder="{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate}}">
        <label for="department_name">{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate}}</label>
      </div>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
      [(currentPage)]="currentPage"
      [(itemsPerPage)]="itemsPerPage"
      [totalItems]="totalItems"
      (pageChange)="pageChanged()"
      (optionChange)="optionChanged()"
      *ngIf="loading === false && totalItems !== 0">
    <button type="button" class="btn btn-dv btn-wide"
      (click)="getExportExcel()">
    {{ 'COMMON.DOWNLOAD' | translate }} Excel
    </button>
    <button
        type="button"
        class="btn btn-dv btn-wide"
        (click)="openModal(null, -1)">
      {{'TEXT.ADD_DEPARTMENT' | translate}}
    </button>
  </app-custom-pagination>

  <div class="float-right" *ngIf="totalItems === 0 && !loading">
    <button
        type="button"
        class="btn btn-dv btn-wide"
        (click)="openModal(null, -1)">
      {{'TEXT.ADD_DEPARTMENT' | translate}}
    </button>
  </div>
  <div class="row m-t-20" *ngIf="totalItems === 0 && !loading">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="scrollable m-t-30">
    <table class="table text-center" *ngIf="totalItems !== 0 && !loading">
      <thead>
        <tr>
          <th scope="col">{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th scope="col">{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-ID' | translate}}</th>
          <th scope="col">{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate}}(EN)</th>
          <th scope="col">{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate}}(TH)</th>
          <th scope="col">{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-ABBREVIATION' | translate}}</th>
          <th scope="col">
            <p-checkbox class="dv-checkbox" (onChange)="selectDeselectAll($event)" [ngModel]="allChecked" binary="true"> </p-checkbox>
          </th>
          <th scope="col" *ngIf="isAdmin || isIT || isAccountant || isAccountantAdmin">{{'TABLE.EDIT' | translate}}</th>
          <th scope="col" *ngIf="isAdmin || isIT || isAccountant || isAccountantAdmin">{{'TABLE.DELETE' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let department of departmentDetails; let index = index">
          <td>{{((currentPage - 1) * itemsPerPage) + index + 1}}</td>
          <td>{{department.code}}</td>
          <td>{{department.name_en}}</td>
          <td>{{department.name_th}}</td>
          <td>{{department.abbreviation }}</td>
          <td style="text-align: center">
            <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="selectedValues[index]" (ngModelChange)="isAllSelect()"></p-checkbox>
          </td>
          <td>
            <i class="fa fa-1x fa-edit text-warning pointer" (click)="openModal(department, department.id)"></i>
          </td>
          <td>
            <i class="fa fa-1x fa-trash text-danger pointer" (click)="confirmDelete(index)"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<department-list-detail #detailModal></department-list-detail>

<ng-template #deleteConfirmation let-modal>
  <div class="modal-header">
    <h5>{{'COMMON.CONFIRMATION'|translate}}</h5>
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <h6>{{'NORMAL.DEPARTMENT-ID'| translate}}: {{ modalData.code }}</h6>
        <h6>{{'COMMON.CONFIRM-DELETE-DEPARTMENT'| translate}}</h6>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide"
              (click)="revertBack()">{{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" (click)="confirmedDelete(modalData.id)">
        {{'COMMON.OK' | translate}}
      </button>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/department/department-list/department-list.component.html